import { IconProps } from "./";
import Icon from "./assets/unlock_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Unlock(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
